// Copyright (c) 2017 Deere & Company

import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const resetCustomer = state =>
    Customer.update(state, {
        $set: getDefaultState().customer
    });

const updateCustomer = (state, action) =>
    Customer.update(state, {
        $set: action.customer
    });

export default (state = getDefaultState().customer, action) => {

    const actionTypes = {
        [actions.RESET_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER]: resetCustomer,
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER]: updateCustomer
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/products-by-customer/reducers/customer.js